export enum PropertyGroupDisplay {
    Grid,
    Flex
}